import React from 'react';
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom'
import Home from './components/Home/Home';
import Header from './components/Layout/Header/Header';
import Courses from './components/Courses/Courses';
import Footer from './components/Layout/Footer/Footer';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import Contact from './components/contact/Contact';
import Request from './components/request/Request';
import About from './components/about/About';
import Suscribe from './components/payment/Suscribe';
import NotFound from './components/Layout/notfound/NotFound';
import PaymentSuccess from './components/payment/PaymentSuccess';
import PaymentFail from './components/payment/PaymentFail';
import CoursePage from './components/coursePage/CoursePage';
import Profile from './components/profile/Profile';
import ChangePassword from './components/profile/ChangePassword';
import UpdateProfile from './components/profile/UpdateProfile';
import Dashboard from './components/admin/Dashboard/Dashboard';
import AdminCourses from './components/admin/AdminCourses/AdminCourses';
import CreateCourse from './components/admin/createcourse/CreateCourse';
import Users from './components/admin/Users/Users';


function App() {
  // window.addEventListener('contextmenu',e=>{
  //   e.preventDefault()
  // })
  return (
  <Router>
    <Header/>
    <Routes>
      <Route  path='/' element={<Home/>}/>
      <Route  path='/courses' element={<Courses/>}/>
      <Route  path='/course/:id' element={<CoursePage/>}/>
      <Route  path='/contact' element={<Contact/>}/>
      <Route  path='/profile' element={<Profile/>}/>
      <Route  path='/changepassword' element={<ChangePassword/>}/>
      <Route  path='/updateprofile' element={<UpdateProfile/>}/>
      <Route  path='/request' element={<Request/>}/>
      <Route  path='/about' element={<About/>}/>
      <Route  path='/login' element={<Login/>}/>
      <Route  path='/register' element={<Register/>}/>
      <Route  path='/forgetpassword' element={<ForgotPassword/>}/>
      <Route  path='/resetpassword/:token' element={<ResetPassword/>}/>
      <Route  path='/suscribe' element={<Suscribe/>}/>
      <Route  path='/paymentsuccess' element={<PaymentSuccess/>}/>
      <Route  path='/paymentfail' element={<PaymentFail/>}/>
      <Route  path='*' element={<NotFound/>}/>
      {/* Admin Routes */}
      <Route path='/admin/dashboard' element={<Dashboard/>} />
      <Route path='/admin/createcourse' element={<CreateCourse/>} />
      <Route path='/admin/courses' element={<AdminCourses/>} />
      <Route path='/admin/users' element={<Users/>} />

    </Routes>
 <Footer/>
  </Router>
  );
}

export default App;
